<template>
    <div class="home-carousel" ref="currentWidth">
        <el-carousel
                :width="carouselWidth + 'px'"
                height="510px"
                :autoplay="false"
                arrow="hover"
        >
            <el-carousel-item v-for="(item,index) in carouselList" :key="index">
                <img :src="item.banner_img" alt="">
            </el-carousel-item>
        </el-carousel>

        <div class="carousel-detail">
            <p class="detail-bold">
                全国<span>配驾包车</span>
            </p>
            <p class="detail-bold-two">
                出行更省心
            </p>
            <p class="detail-serve-user">
                32,305,702用户的共同选择
            </p>
            <p class="detail-normal">
                为您节省70%的出行时间 减少您90%的搭乘苦恼 提升您100%的旅途愉悦
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeCarousel",
        props: {
            carouselList: {
                type: Array,
                default: [],
            }
        },
        data() {
            return {
                carouselWidth: '',
                /*carouselList: [
                    {
                        banner_img: require('@/assets/images/index/home_img_banner.png'),
                    },
                    {
                        banner_img: require('@/assets/images/index/home_img_banner.png'),
                    },
                    {
                        banner_img: require('@/assets/images/index/home_img_banner.png'),
                    }
                ]*/
            }
        },
        // 根据屏幕自适应轮播图大小
        mounted() {
            this.carouselWidth = this.$refs.currentWidth.clientWidth;
        }

    }
</script>

<style scoped>
    .home-carousel {
        width: 100%;
        min-width: 1200px;
        height: 510px;
        background: #fff;
        position: relative;
    }

    /*.home-carousel el-carousel {
        width: 100%;
        margin: 0 auto;
    }*/

    .home-carousel el-carousel el-carousel-item img {
        width: 100%;
    }

    .carousel-detail {
        width: 500px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -600px;
        margin-top: -130px;
        z-index: 2;
    }

    .detail-bold {
        width: 420px;
        margin-left: 70px;
        height: 70px;
        line-height: 70px;
        font-size: 62px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
    }

    .detail-bold span {
        color: #FFEB7C;
    }

    .detail-bold-two {
        width: 360px;
        margin-left: 70px;
        margin-top: 15px;
        height: 70px;
        line-height: 70px;
        font-size: 62px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
    }

    .detail-serve-user {
        margin-left: 70px;
        margin-top: 20px;
        width: 360px;
        height: 30px;
        line-height: 30px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
    }

    .detail-normal {
        margin-left: 40px;
        margin-top: 16px;
        width: 400px;
        line-height: 30px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/pages/home/components/homeCarousel.vue